import { MapView } from '../map/map-view.jsx';

/**
 * Full-page map. All map logic lives in the reusable <MapView> — this page
 * is a thin shell so the same component can also be embedded inside modals
 * (e.g. the coordinate picker on /nodes).
 */
export function MapPage() {
  return <MapView mode="full" />;
}
